import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import {
  PageHeader,
  InfoBox,
  RichText,
  PageMetadata,
} from '@redturtle/iovisit-theme/components/Views';
import Contacts from '@redturtle/iovisit-theme/components/Blocks/Contacts/Body';

const messages = defineMessages({
  timetable: { id: 'timetable', defaultMessage: 'Orari' },
  restaurant_type: {
    id: 'restaurant_type',
    defaultMessage: 'Tipologia ristorante',
  },
  services: {
    id: 'services',
    defaultMessage: 'Servizi',
  },
  cuisine_type: {
    id: 'cuisine_type',
    defaultMessage: 'Tipologia cucina',
  },
  contacts: {
    id: 'contacts',
    defaultMessage: 'Contatti',
  },
});

const VocabularyField = ({ title, content }) =>
  content?.length > 0 ? (
    <>
      {title && <h3>{title}</h3>}
      <p>{content.map((t) => t.title).join(', ')}</p>
    </>
  ) : null;

const RestaurantView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const restaurantType = VocabularyField({
    title: intl.formatMessage(messages.restaurant_type),
    content: content.restaurant_type,
  });
  const services = VocabularyField({
    title: intl.formatMessage(messages.services),
    content: content.services,
  });
  const cuisineType = VocabularyField({
    title: intl.formatMessage(messages.cuisine_type),
    content: content.cuisine_type,
  });

  const infoBoxHasData = !!timetable;

  return (
    <div id="page-restaurant" className="ui container">
      {infoBoxHasData && <InfoBox>{timetable}</InfoBox>}

      {restaurantType}
      {services}
      {cuisineType}

      <hr />
      <Contacts properties={content} />
      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default RestaurantView;
